import React, { useEffect, useState } from 'react';
import '../OffersMain/offersmain.css';

function svgPlaceholderDataUri(text) {
  const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
  <rect width="400" height="300" fill="#e2e8f0"/>
  <text x="200" y="150" font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial" font-size="20" fill="#4a5568" text-anchor="middle" dominant-baseline="middle">${String(text || '').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</text>
</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

const FALLBACK_IMAGE = svgPlaceholderDataUri('Sin imagen');
const ERROR_IMAGE = svgPlaceholderDataUri('Error');

// Helper: extract page_id from a fanpage URL (prefers view_all_page_id)
function getPageIdFromFanpageUrl(url) {
  if (!url || typeof url !== 'string') return null;
  // Normalize HTML-encoded ampersands
  const s = url.replace(/&amp;/g, '&');
  try {
    const u = new URL(s);
    const id =
      u.searchParams.get('view_all_page_id') ||
      u.searchParams.get('page_id') ||
      u.searchParams.get('id');
    if (id) return id;
  } catch (_) {
    // Fallback regex for non-standard or partial URLs
    const m = s.match(/[?&](view_all_page_id|page_id|id)=([^&]+)/i);
    if (m) return decodeURIComponent(m[2]);
  }
  return null;
}

function getAdsErrorLabel(errorType) {
  switch (errorType) {
    case 'timeout':
      return 'Tiempo de espera agotado';
    case 'http':
      return 'Error HTTP al consultar anuncios';
    case 'network':
      return 'Error de red al consultar anuncios';
    case 'aborted':
      return 'Consulta cancelada';
    default:
      return 'No disponible';
  }
}

// Small animated dots indicator " . .. ... "
function DotDots({ interval = 400 }) {
  const [dots, setDots] = useState('');
  useEffect(() => {
    const id = setInterval(() => setDots((d) => (d.length >= 3 ? '' : d + '.')), interval);
    return () => clearInterval(id);
  }, [interval]);
  // Reserve width to avoid layout shift (3 chars)
  return <span style={{ display: 'inline-block', width: 18 }} aria-live="polite">{dots}</span>;
}

const OffersCard = ({ offer, onEdit, onDelete, pendingPids, adsBadges, adsErrors }) => {
  const pid = getPageIdFromFanpageUrl(offer?.URL_AdsFanpage);
  const isPending = !!(pendingPids && pid && pendingPids.has(pid));
  const numericAds = Number(offer?.NumberOfAds);
  const hasNumber = Number.isFinite(numericAds);
  const badge = pid && adsBadges ? adsBadges.get(pid) : null; // 'up' | 'fire' | undefined
  const errorType = pid && adsErrors ? adsErrors.get(pid) : null;

  return (
    <div className="card">
      <img
        src={offer.Imagen || FALLBACK_IMAGE}
        alt={`Imagen de ${offer.Titulo}`}
        className="cardImage"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = ERROR_IMAGE;
        }}
      />
      <div className="cardContent">
        <h3 className="cardTitle">{offer.Titulo}</h3>
        <p className="cardText">
          <strong>Landing Page:</strong>{' '}
          <a href={offer.LandingPage} target="_blank" rel="noopener noreferrer" className="cardLink">{offer.LandingPage}</a>
        </p>
        <p className="cardText">
          <strong>Fanpage:</strong>{' '}
          <a href={offer.URL_AdsFanpage} target="_blank" rel="noopener noreferrer" className="cardLink">{offer.URL_AdsFanpage}</a>
        </p>
        <p className="cardText"><strong>Tipo:</strong> {offer.TipoOferta || 'N/A'}</p>
        <p className="cardText" style={{ marginBottom: '1rem' }}>
          <strong>Anuncios:</strong>{' '}
          {badge === 'fire' ? '🔥 ' : badge === 'up' ? '⬆️ ' : ''}
          {hasNumber ? numericAds : errorType ? '—' : '…'}
          {isPending && <DotDots />}
          {errorType && !hasNumber && <span title={getAdsErrorLabel(errorType)}> ⚠️</span>}
        </p>
        <div className="cardActions">
          {/* <button onClick={() => onEdit(offer)} className="button buttonEdit">Editar</button> */}
          {/* <button onClick={() => onDelete(offer.id)} className="button buttonDelete">Eliminar</button> */}
        </div>
      </div>
    </div>
  );
};

export default OffersCard;
